import { type ProvidersMapProps } from "./types";

export const providersMap: ProvidersMapProps = {
  azure_ad: {
    brand: "microsoft",
  },
  one_login: {
    brand: "oneLogin",
  },
  okta: {
    brand: "okta",
  },
  custom: {
    brand: "default",
  },
};
